export default {
    methods: {
        //LOCAL RECORD
        //duplicate function: todo search for newRecord usage and replace with getCreateInputsObject(), then delete
        newRecord() {
            return this.getObjectTemplateByDefinitionType('create');
        },
        getCreateInputsObject() {
            return this.getObjectTemplateByDefinitionType('create');
        },
        getUpdateInputsObject() {
            return this.getObjectTemplateByDefinitionType('update');
        },
        getObjectTemplateByDefinitionType(type, _default = {}) {
            try {
                let schema = {};
                for (let input of app.sdk[this.dbName][`${this.dbTableName}_${type}_inputs`]) {
                    let value = typeof _default[input.name] !== 'undefined' ? _default[input.name] : null;
                    schema[input.name] = value;
                }
                return schema;
            } catch (err) {
                return {};
            }
        },
        setLocalRecord(record) {
            this.l_localRecord = record;
            this.l_originalRecord = JSON.parse(JSON.stringify(this.l_localRecord));
        },
        getLocalRecord() {
            return JSON.parse(JSON.stringify(this.l_localRecord));
        },
        setLocalRecordToNewRecord(_default = {}) {
            this.setFiles([]);
            this.setLocalRecord(this.getObjectTemplateByDefinitionType('create', _default));
            this.l_result.read = {};
        },
        isLocalRecordNewRecord() {
            let localRecord = this.getLocalRecord();
            return (typeof localRecord[`${this.l_defaultUpdateRecordIdNameInput}`] == 'undefined' || localRecord[`${this.l_defaultUpdateRecordIdNameInput}`] == null)
                && (typeof localRecord[`${this.defaultReadRecordIdNameOutput}`] == 'undefined' || localRecord[`${this.defaultReadRecordIdNameOutput}`] == null);
        },
        updateLocalRecord(data) {
            let aux = JSON.parse(JSON.stringify(this.l_localRecord));
            for (let key in data) {
                aux[key] = data[key]
            }
            this.setLocalRecord(aux);
        },
        restoreLocalRecord() {
            this.setLocalRecord(this.l_originalRecord);
        }
    }
}
